export default "__VITE_ASSET__HnLfk$sO__"